import React from "react";
import ButtonComp from "../buttons/buttonComp/buttonComp";

type IProps = {
    backgroundColor?: string;
    textColor?: boolean;
    url?: string;
}

const SignUpButton = (props: IProps) => {
    return (
        <ButtonComp fullWidth={true} backgroundColor={props.backgroundColor} visible={false} uppercase={true} textColor={props.textColor} url={props.url}>
            <React.Fragment>
                Hemen Ücretsiz Üye Ol
            </React.Fragment>
        </ButtonComp>
    );
}

export default SignUpButton;
